<template>
  <el-dialog title="每日发放限额" :visible.sync="visible" width="500px" :close-on-click-modal="false" @close="handleClose">
    <el-form :model="formData" label-width="120px" class="backgroundForm">
      <!-- 每日发放规则 -->
      <el-form-item label="每日发放规则:">
        <el-radio-group v-model="formData.dailyLimitType">
          <el-radio :label="0">按每日配置数量</el-radio>
          <el-radio :label="1">按闲忙时配置数量</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 按每日配置数量 -->
      <el-form-item v-if="formData.dailyLimitType === 0" label="每日发放:">
        <el-input v-model.number="formData.dailyLimit" placeholder="请输入" style="width: 200px" type="number"
          @input="formData.dailyLimit = getNumberData(1, $event, 0, 1)"></el-input>
        <span style="margin-left: 8px">份</span>
      </el-form-item>

      <!-- 按闲忙时配置数量 -->
      <template v-if="formData.dailyLimitType === 1">
        <el-form-item label="闲时发放:">
          <el-input v-model.number="formData.idleLimit" placeholder="请输入" style="width: 200px" type="number"
            @input="formData.idleLimit = getNumberData(1, $event, 0, 1)"></el-input>
          <span style="margin-left: 8px">份</span>
        </el-form-item>

        <el-form-item label="忙时发放:">
          <el-input v-model.number="formData.busyLimit" placeholder="请输入" style="width: 200px" type="number"
            @input="formData.busyLimit = getNumberData(1, $event, 0, 1)"></el-input>
          <span style="margin-left: 8px">份</span>
        </el-form-item>
        <tip-box>时限说明：闲时代表晚上23点至次日7点，其余时间代表忙时;</tip-box>
      </template>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import tipBox from '@/components/tip-box'
export default {
  name: 'SetLimitDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 初始数据
    initData: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    tipBox,
  },
  data() {
    return {
      formData: {
        dailyLimitType: 0, // 默认选中按每日配置数量
        dailyLimit: null, // 每日发放数量
        idleLimit: null, // 闲时发放数量
        busyLimit: null // 忙时发放数量
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initFormData()
      }
    },
    initData: {
      handler() {
        this.initFormData()
      },
      deep: true
    }
  },
  methods: {
    // 初始化表单数据
    initFormData() {
      this.formData = {
        dailyLimitType: 0,
        dailyLimit: null,
        idleLimit: null,
        busyLimit: null
      }
      this.formData = { ...this.formData, ...this.initData }
    },

    // 确定按钮
    handleConfirm() {
      // 验证数据
      if (this.formData.dailyLimitType === 0) {
        if (!this.formData.dailyLimit || this.formData.dailyLimit <= 0) {
          this.$message.warning('请输入有效的每日发放数量')
          return
        }
        if (Number(this.formData.dailyLimit) > this.formData.totalAmount) {
          this.$message.warning('每日发放数量不能大于奖品总数')
          return
        }
      } else if (this.formData.dailyLimitType === 1) {
        if (!this.formData.idleLimit || this.formData.idleLimit <= 0) {
          this.$message.warning('请输入有效的闲时发放数量')
          return
        }
        if (!this.formData.busyLimit || this.formData.busyLimit <= 0) {
          this.$message.warning('请输入有效的忙时发放数量')
          return
        }
        if (Number(this.formData.idleLimit) + Number(this.formData.busyLimit) > this.formData.totalAmount) {
          this.$message.warning('闲时和忙时发放数量之和不能大于奖品总数')
          return
        }
      }

      // 发送确认事件
      this.$emit('confirm', { ...this.formData })
      this.handleClose()
    },

    // 取消按钮
    handleCancel() {
      this.handleClose()
    },

    // 关闭弹窗
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-radio {
  margin-right: 20px;
}
</style>